import {BrowserRouter, Route, Routes} from "react-router-dom";
import Entrypoint from "../component/Entrypoint";
import EntrepreneurInterventionList from "../component/private/entrepreneur/intervention/InterventionList";
import SuggestionList from "../component/private/entrepreneur/suggestion/SuggestionList";
import MenuEntrepreneur from "../component/private/entrepreneur/Menu";
import RouteWrapper from "../component/RouteWrapper";
import route from "../enum/route";
import EmergencyIntervention from "../component/private/intervention/emergency/Intervention";
import B2cIntervention from "../component/private/intervention/b2c/Intervention";
import B2csduIntervention from "../component/private/intervention/b2csdu/Intervention";
import InsuranceIntervention from "../component/private/intervention/insurance/Intervention";
import SuggestionController from "../component/private/suggestion/SuggestionController";
import BrowserAuth from "../component/BrowserAuth";

export default function () {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<RouteWrapper component={<Entrypoint/>}/>}/>
                <Route element={<RouteWrapper component={<MenuEntrepreneur/>}/>}>
                    <Route path={route.ENTREPRENEUR_INTERVENTIONS} element={<EntrepreneurInterventionList/>}/>
                    <Route path={route.ENTREPRENEUR_SUGGESTIONS} element={<SuggestionList/>}/>
                </Route>
                <Route
                    path={route.ENTREPRENEUR_SUGGESTION}
                    element={<RouteWrapper component={<SuggestionController/>}/>}
                />
                <Route
                    path={route.ARTISAN_EMERGENCY_INTERVENTION}
                    element={<RouteWrapper component={<EmergencyIntervention/>}/>}
                />
                <Route
                    path={route.ARTISAN_B2C_INTERVENTION}
                    element={<RouteWrapper component={<B2cIntervention/>}/>}
                />
                <Route
                    path={route.ARTISAN_B2CSDU_INTERVENTION}
                    element={<RouteWrapper component={<B2csduIntervention/>}/>}
                />
                <Route
                    path={route.ARTISAN_INSURANCE_INTERVENTION}
                    element={<RouteWrapper component={<InsuranceIntervention/>}/>}
                />
                <Route
                    path={route.ROOT}
                    element={<BrowserAuth/>}
                />
            </Routes>
        </BrowserRouter>
    )
}